//平铺路由
const routerTile = data => {
  let arr = [];
  data.forEach(p => {
    let childrenArr = [];
    if (p.children) {
      childrenArr = routerTile(p.children);
    }
    delete p.children;
    arr.push(p);
    arr = arr.concat(childrenArr);
  });
  return arr;
};

export default routerTile;
